import { type BasicTaskHandlerSchema } from 'modules/procurement/components/procurementTypes/Workflows/sidePanels/schemas/basicTaskHandler'
import { HandlerFormComponentPayload } from 'modules/workflows/contexts/WorkflowContext'
import { DEFAULT_DURATION_UNIT, isValidDateUnit } from 'modules/workflows/lib/durationUnit'

import { mapEmployeeSegments } from './employeeSegmentMapper'

export const basicTaskApproveNodeToSchemaMapper = (
  payload: HandlerFormComponentPayload
): BasicTaskHandlerSchema['nodeData']['payload'] => {
  const assignee_ids = payload.assignee_ids
  const due_on_unit = String(payload.due_on_unit)
  const due_on_value = payload.due_on_value
  const numericDueOnValue =
    typeof due_on_value === 'number' && !isNaN(due_on_value) ? due_on_value : 1

  const assigneeIds = Array.isArray(assignee_ids)
    ? assignee_ids.map((assignee_id) => Number(assignee_id))
    : []

  const fallbackAssigneeIds = Array.isArray(payload.fallback_assignee_ids)
    ? payload.fallback_assignee_ids.map((id) => Number(id))
    : undefined

  const assigneeSegments = mapEmployeeSegments(payload.assignee_segments)
  const fallbackAssigneeSegments = mapEmployeeSegments(payload.fallback_assignee_segments)

  return {
    category: 'finance',
    due_on_unit: isValidDateUnit(due_on_unit) ? due_on_unit : DEFAULT_DURATION_UNIT,
    due_on_value: numericDueOnValue,
    assignee_ids: assigneeIds,
    title: String(payload.title ?? ''),
    description: String(payload.description ?? ''),
    ...(assigneeSegments && assigneeSegments.length > 0
      ? { assignee_segments: assigneeSegments }
      : {}),
    ...(fallbackAssigneeIds && fallbackAssigneeIds.length > 0
      ? { fallback_assignee_ids: fallbackAssigneeIds }
      : {}),
    ...(fallbackAssigneeSegments && fallbackAssigneeSegments.length > 0
      ? { fallback_assignee_segments: fallbackAssigneeSegments }
      : {}),
  }
}
